import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule } from 'Angular/features/directives/icon/icon.module';

@Component({
    selector: 'ycn-agent-download-link',
    templateUrl: './agent-download-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconModule],
})
export class AgentDownloadLinkComponent {
    protected readonly url = input.required<string>();

    protected readonly title = input.required<string>();
}
